<template>
    <div class="filter__wrapper" v-if="title != 'Custom'">
        <h2 class="filter__wrapper--headline">{{title}}</h2>
        <ul  v-if="layout === 'rating'" class="filter__wrapper--filters">
            <li v-for="entry in entries"
                :class="isActive(entry.selected)"
                @click="selectEntry(entry.name, entry.selected)"
                :key="entry.name">
                <input v-if="!entry.selected" type="radio" name="downloads" />
                <span v-else class="checkbox--fake radio">
                    <div class="bullet">&nbsp;</div>
                </span>
                <label class="star__wrapper" :for="entry.name">
                    <span>
                        <svg v-for="idx in parseInt(entry.name)" :key="idx" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 260 245"><path  fill="#575C61" d="m55,237 74-228 74,228L9,96h240"/></svg>
                        <svg v-for="idx in parseInt(5 - entry.name)" :key="idx" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 260 245"><path fill="rgb(87,92,97, 0.25)" d="m55,237 74-228 74,228L9,96h240"/></svg>
                    </span>
                    <span class="star__text">{{entry.label}}</span>
                </label>
            </li>
        </ul>
        <ul v-else-if="layout === 'downloads'" class="filter__wrapper--filters">
            <li v-for="entry in entries" 
                :class="isActive(entry.selected)"
                @click="selectEntry(entry.name, entry.selected)" 
                :key="entry.name">
                    <input v-if="!entry.selected" type="radio" name="downloads" />
                    <span v-else class="checkbox--fake radio">
                        <div class="bullet">&nbsp;</div>
                    </span>
                    <label :for="entry.name">{{entry.label}}</label>
            </li>
        </ul>
        <ul v-else class="filter__wrapper--filters">
            <template v-for="entry in entries" :key="entry.name">
                <li v-if="entry.visible"
                    :class="isActive(entry.selected)"
                    @click="selectEntry(entry.id, entry.selected)" >
                    <input v-if="!entry.selected" type="checkbox" />
                    <span v-else class="checkbox--fake">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24">
                            <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" fill="#FFFFFF"></path>
                        </svg>
                    </span>
                    <label :for="entry.name">{{entry.label}} <b v-if="entry.name != 'loxone' && entry.name != 'vendor' && entry.name != 'community' && entry.name != 'loxone_ready'">({{entry.items}})</b>
                        <svg style="vertical-align: top;margin-top: 3px;" v-if="entry.name == 'loxone_ready'"  width="16px" height="16px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Loxone-Ready" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Loxone-Ready---Startseite" transform="translate(-1168.000000, -1177.000000)" fill="#69C350"><g id="Kachel" transform="translate(936.000000, 1153.000000)"><g id="Loxone-Ready" transform="translate(232.000000, 24.000000)"><path d="M17.3276015,0 L0,0 L0,26.679417 L17.3276015,0 Z M31.9997179,5.98447313 L31.9997179,32 L15.1067205,32 L31.9990127,32 L31.9990127,5.9855667 L31.9997179,5.98447313 Z" id="Shape"></path><polygon id="Path" fill-opacity="0.4" fill-rule="nonzero" points="15.1070496 31.9999525 32 5.98447313 32 31.9999525"></polygon><polygon id="Path" fill-opacity="0.7" points="17.3276015 0 0 26.679417 0 32 15.1067205 32 31.9997179 5.98447313 31.9997179 0"></polygon></g></g></g></g></svg>
                        <svg style="vertical-align: top;margin-top: 3px;" v-if="entry.name == 'loxone'" width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" data-v-0a65d77f=""><g id="icons-/-filled-/-badge-loxone" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" data-v-0a65d77f=""><path d="M12.8163265,0.471306342 L21.5759783,5.52869366 C22.0811229,5.82033904 22.3923048,6.35932193 22.3923048,6.94261268 L22.3923048,17.0573873 C22.3923048,17.6406781 22.0811229,18.179661 21.5759783,18.4713063 L12.8163265,23.5286937 C12.3111819,23.820339 11.6888181,23.820339 11.1836735,23.5286937 L2.42402169,18.4713063 C1.91887707,18.179661 1.60769515,17.6406781 1.60769515,17.0573873 L1.60769515,6.94261268 C1.60769515,6.35932193 1.91887707,5.82033904 2.42402169,5.52869366 L11.1836735,0.471306342 C11.6888181,0.179660963 12.3111819,0.179660963 12.8163265,0.471306342 Z M17.7310553,7.81768175 C17.3542213,7.41393107 16.7214324,7.39211077 16.3176817,7.76894473 L16.3176817,7.76894473 L9.524,14.109 L7.70710678,12.2928932 L7.61289944,12.2097046 C7.22060824,11.9046797 6.65337718,11.9324093 6.29289322,12.2928932 C5.90236893,12.6834175 5.90236893,13.3165825 6.29289322,13.7071068 L6.29289322,13.7071068 L8.79289322,16.2071068 L8.88476204,16.2884594 C9.2671574,16.5875373 9.818677,16.5704538 10.1823183,16.2310553 L10.1823183,16.2310553 L17.6823183,9.23105527 L17.768704,9.13977076 C18.087067,8.75822442 18.078902,8.19037468 17.7310553,7.81768175 Z" id="Combined-Shape" fill="#69C350" data-v-0a65d77f=""></path></g></svg>
                        <svg style="vertical-align: top;margin-top: 3px;" v-if="entry.name == 'vendor'" width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" data-v-0a65d77f=""><g id="icons-/-filled-/-badge-vendor" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" data-v-0a65d77f=""><path d="M12.8163265,0.471306342 L21.5759783,5.52869366 C22.0811229,5.82033904 22.3923048,6.35932193 22.3923048,6.94261268 L22.3923048,17.0573873 C22.3923048,17.6406781 22.0811229,18.179661 21.5759783,18.4713063 L12.8163265,23.5286937 C12.3111819,23.820339 11.6888181,23.820339 11.1836735,23.5286937 L2.42402169,18.4713063 C1.91887707,18.179661 1.60769515,17.6406781 1.60769515,17.0573873 L1.60769515,6.94261268 C1.60769515,6.35932193 1.91887707,5.82033904 2.42402169,5.52869366 L11.1836735,0.471306342 C11.6888181,0.179660963 12.3111819,0.179660963 12.8163265,0.471306342 Z M17.7310553,7.81768175 C17.3542213,7.41393107 16.7214324,7.39211077 16.3176817,7.76894473 L16.3176817,7.76894473 L9.524,14.109 L7.70710678,12.2928932 L7.61289944,12.2097046 C7.22060824,11.9046797 6.65337718,11.9324093 6.29289322,12.2928932 C5.90236893,12.6834175 5.90236893,13.3165825 6.29289322,13.7071068 L6.29289322,13.7071068 L8.79289322,16.2071068 L8.88476204,16.2884594 C9.2671574,16.5875373 9.818677,16.5704538 10.1823183,16.2310553 L10.1823183,16.2310553 L17.6823183,9.23105527 L17.768704,9.13977076 C18.087067,8.75822442 18.078902,8.19037468 17.7310553,7.81768175 Z" id="Combined-Shape" fill="#575C61" data-v-0a65d77f=""></path></g></svg>
                    </label>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'PluginFilter',
  props: {
      title: {
          type: String,
          required: true,
      },
      value: {
          type: String,
          required: true,
      },
      entries: {
          type: Object,
          required: true,
      },
      layout: {
          type: String,
          required: false,
      }
  },
  emits: ['toggle-filter'],
    methods: {
        selectEntry(id, selected) {
            var filter = id;
            var filterby = this.value;
            var isSelected = selected;
            this.$store.dispatch('toggleFilter', {filter, filterby, isSelected});
        },
        isActive(active) {
            if(active) {
                return "active";
            }
            return null;
        },
        showAllEntries() {
            for (const [key, value] of Object.entries(this.entries)) {
                value.visible = true;
            }
        }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .filter__wrapper{
        padding-bottom: 55px;
    }
    .filter__wrapper--headline{
        margin: 0;
        font-size: 23px;
        line-height: 30px;
        color: #000000;
        padding-bottom: 25px;
        font-weight: normal;
    }
    .filter__wrapper--filters{
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .filter__wrapper--filters li{
        margin-bottom: 10px;
        cursor: pointer;
        position: relative;
    }
    .filter__wrapper--filters li input{
        width: 16px;
        height: 16px;
        border: 1px solid #979797;
        background-color: rgba(255, 255, 255, 0.7);
        appearance: none;
        outline: none;
        margin: 0;
        vertical-align: middle;
        cursor: pointer;
    }
    .filter__wrapper--filters li input[type="radio"] {
        border-radius: 50%;;
    }
    .filter__wrapper--filters li label{
        font-size: 16px;
        color: #575C61;
        line-height: 22px;
        vertical-align: middle;
        padding-left: 7px;
        display: inline-block;
        cursor: pointer;
    }
    .star__wrapper{
        font-size: 0;
        line-height: 0;
        padding-top: 1px;
    }

    .star__wrapper span{
        padding-right: 5px;
    }

    .star__text{
        font-size: 16px;
        line-height: 22px;
    }
</style>